import { Map, List } from "immutable";
import { ACTIONS } from "features/planner/planner.constants";

const initialState = Map({
  visible: null,
});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_CARD_MOVES: {
      if (error) return state;

      const { cardId } = action;

      return state.set(cardId.toString(), List(payload));
    }

    case ACTIONS.CREATE_CARD_MOVE: {
      if (error) return state;

      return state.update(action.cardId.toString(), cardMoves =>
        cardMoves ? cardMoves.push(payload) : List([payload]),
      );
    }

    case ACTIONS.DISPLAY_CARD_MOVES: {
      const { cardId } = action;

      return state.set("visible", cardId.toString());
    }

    default:
      return state;
  }
};
